import clsx from 'clsx'
import Image from 'next/image'

/* styling */
import styles from './_.module.css'

interface Props {
  title: string
  description: string
  statistics: {
    stat: string
    color: string | null
    description: string
  }[]
  influencerList: {
    name: string
    designation: string
    image?: StrapiImageFile
  }[]
}

function EventsOverview({
  title,
  description,
  statistics,
  influencerList
}: Props): JSX.Element {
  return (
    <section className="container | font-heading | py-10 md:py-18">
      <div className="text-center | mb-10 md:mb-14">
        <h2 className="text-4xl md:text-5xl font-semibold text-blue-90 | mb-2 md:mb-6">
          {title}
        </h2>
        <p className="text-base md:text-2xl text-gray-60">{description}</p>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center gap-10 md:gap-24 | max-w-col-3 md:max-w-col-10 mx-auto text-left md:text-center | mb-14 md:mb-24">
        {statistics?.map(statistic => (
          <div
            key={statistic.stat}
            className={clsx(
              'flex justify-center items-center md:flex-col gap-4 md:gap-0',
              styles.gradient
            )}
          >
            <div
              className={clsx(
                styles.gradientText,
                'text-2xl md:text-5xl font-bold'
              )}
              dangerouslySetInnerHTML={{ __html: statistic.stat }}
            />
            <span
              className="text-2xl md:text-3xl | inline-block mb-0 md:mb-2"
              dangerouslySetInnerHTML={{ __html: statistic.description }}
            />
          </div>
        ))}
      </div>
      <div
        className={clsx(
          'grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-12 | pr-2 md:pr-18 max-h-[428px] md:max-h-[676px] overflow-y-scroll snap-y snap-mandatory',
          styles.scrollbar
        )}
      >
        {influencerList.map(influencer => {
          return (
            <article key={influencer.name}>
              <div className="font-heading text-black bg-white | rounded-lg | max-w-col-6 mx-auto">
                {influencer?.image?.url ? (
                  <Image
                    src={influencer.image.url}
                    alt={influencer.image.alternativeText ?? ''}
                    width={influencer.image.width}
                    height={influencer.image.height}
                    className="w-32 h-32 md:w-52 md:h-52 object-cover | rounded-full border border-blue-40 | mb-5 md:mb-7 mx-auto"
                  />
                ) : null}
                <div className="text-center">
                  <h3
                    className="text-base md:text-2xl font-bold | mb-2"
                    dangerouslySetInnerHTML={{ __html: influencer.name }}
                  />
                  <span
                    className="text-xs md:text-sm"
                    dangerouslySetInnerHTML={{ __html: influencer.designation }}
                  />
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default EventsOverview
